import axios from '../modules/AxiosInstance';
import Environment from '../modules/Environment';
import store from '../store';
import { PAYIT_TENANT_USER_ID, } from '../modules/Constants';

const ClientTransformService = (() => {
  const service = {};
  const BASE_URL = `${Environment.getBaseURL()}`;

  service.getAllCTSServiceOfferings = () => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;
    return axios.get(`${BASE_URL}/cts-offerings`, {
      headers,
    });
  };

  return service;
})();

export default ClientTransformService;
